/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const POIS_SERVICE = {
    list,
    add,
    edit,
    get,
    updateStatus,
    getCoordinates
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Pois";

/* Services */
function list(params)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);    

    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, params, requestOptions);
}

function add(poi, image) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]); 
    
   let formData = new FormData();
    formData.append("Latitude", poi.latitude);
    formData.append("Longitude", poi.longitude);

    poi.categories.forEach(element => {
        var index = poi.categories.indexOf(element);
        formData.append(`Categories[${index}]`, element);
    });

    for (const [key, value] of Object.entries(poi.names)) {
        formData.append(`Names[${key}]`, value);
    }

    for (const [key, value] of Object.entries(poi.descriptions)) {
        formData.append(`Descriptions[${key}]`, value);
    }

    formData.append("Photo", image, image.name);

    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function edit(poi, image) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]); 

    let formData = new FormData();
    formData.append("Id", poi.id);
    formData.append("Latitude", poi.latitude);
    formData.append("Longitude", poi.longitude);

    poi.categories.forEach(element => {
        var index = poi.categories.indexOf(element);
        formData.append(`Categories[${index}]`, element);
    });

    for (const [key, value] of Object.entries(poi.names)) {
        formData.append(`Names[${key}]`, value);
    }

    for (const [key, value] of Object.entries(poi.descriptions)) {
        formData.append(`Descriptions[${key}]`, value);
    }

    if(image instanceof Blob)
    {
        formData.append("Photo", image, image.name);
    }
    else
    {
        formData.append("Photo", image);
    }

    const requestOptions = {
        method: 'PUT',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function get(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetPoi", id]);    
    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader()}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function updateStatus(id) {
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "Status", id]); 

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function getCoordinates(id)
{   
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "Coordinates"]);  
    var queryParams = { "placeId":id};
    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
    
}

